import {FC, useState} from 'react'
import {Link} from 'react-router-dom'
import styled from '@emotion/styled'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {useUsermenuData} from '../../hooks/useUserMenuData'
import {useSidebar} from './SidebarContext'
import {SidebarMenu} from './SidebarMenu'

const NAVY = '#00335d'
const NAVY_DARKER = '#002c50'
const ACCENT = '#009ef7'
const WIDTH = 300
const WIDTH_MIN = 75
const BREAKPOINT = 992

const Styled = styled.aside`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 110;
  display: flex;
  flex-direction: column;
  width: ${WIDTH}px;
  background-color: ${NAVY};
  box-shadow: 10px 0 30px rgba(0, 30, 57, 0.13);
  transition: width 0.3s ease, transform 0.3s ease;

  .sb-logo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    height: 64px;
    padding: 0 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    background-color: ${NAVY_DARKER};

    img.wide {
      height: 26px;
    }
    img.mini {
      display: none;
      height: 32px;
    }
  }

  .sb-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid transparent;
    border-radius: 9px;
    background: transparent;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.55);
    transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease,
      transform 0.3s ease;

    &:hover {
      color: #fff;
      border-color: rgba(255, 255, 255, 0.08);
      background-color: rgba(255, 255, 255, 0.08);
    }
  }

  .sb-scroll {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 14px 12px 28px;

    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(255, 255, 255, 0.15);
      border-radius: 4px;
    }
  }

  /* ---------- itens do menu ---------- */
  .sb-link {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-height: 44px;
    margin-bottom: 2px;
    padding: 5px 8px;
    border: 1px solid transparent;
    border-radius: 11px;
    background: transparent;
    color: rgba(255, 255, 255, 0.82);
    font-size: 13px;
    text-align: left;
    text-decoration: none;
    cursor: pointer;
    transition: transform 0.16s ease, background-color 0.16s ease, border-color 0.16s ease,
      box-shadow 0.16s ease, color 0.16s ease;

    &:hover {
      color: #fff;
      border-color: rgba(255, 255, 255, 0.07);
      background-color: rgba(255, 255, 255, 0.07);
      transform: translateX(2px);
    }

    &.active {
      color: #fff;
      border-color: rgba(255, 255, 255, 0.13);
      background-color: ${ACCENT};
      box-shadow: 0 7px 16px rgba(0, 111, 181, 0.24);
    }

    &.here {
      color: #fff;
      border-color: rgba(255, 255, 255, 0.07);
      background-color: rgba(0, 158, 247, 0.16);
    }
  }

  .sb-label {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .sb-icon-shell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 9px;
    background-color: rgba(255, 255, 255, 0.075);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
    transition: transform 0.16s ease, background-color 0.16s ease, border-color 0.16s ease,
      box-shadow 0.16s ease;
  }

  .sb-item-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: inherit;

    svg {
      display: block;
      width: 20px;
      height: 20px;
      filter: drop-shadow(0 1px 1px rgba(0, 24, 46, 0.16));
    }
  }

  .sb-link:hover .sb-icon-shell {
    border-color: rgba(255, 255, 255, 0.14);
    background-color: rgba(255, 255, 255, 0.12);
    transform: scale(1.04);
  }

  .sb-link.active .sb-icon-shell {
    border-color: rgba(255, 255, 255, 0.72);
    background-color: rgba(255, 255, 255, 0.94);
    box-shadow: 0 3px 9px rgba(0, 49, 88, 0.2);
  }

  .sb-home {
    margin-bottom: 7px;
  }

  /* ---------- seções ---------- */
  .sb-section {
    margin-top: 19px;
  }

  .sb-section-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 3px 8px 8px;
  }

  .sb-section-body {
    margin-left: 10px;
    padding-left: 7px;
    border-left: 1px solid rgba(255, 255, 255, 0.09);
  }

  .sb-icon-shell-section {
    width: 34px;
    height: 34px;
    border-color: rgba(255, 255, 255, 0.1);
    background-color: rgba(255, 255, 255, 0.1);

    .sb-item-icon svg {
      width: 21px;
      height: 21px;
    }
  }

  .sb-section-title {
    color: rgba(255, 255, 255, 0.57);
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.085em;
    line-height: 1.3;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* ---------- acordeão ---------- */
  .sb-chevron {
    flex-shrink: 0;
    color: rgba(255, 255, 255, 0.45);
    transition: transform 0.2s ease, color 0.2s ease;
  }

  .sb-accordion-toggle:hover .sb-chevron,
  .sb-accordion.open > .sb-accordion-toggle .sb-chevron {
    color: rgba(255, 255, 255, 0.8);
  }

  .sb-accordion.open > .sb-accordion-toggle .sb-chevron {
    transform: rotate(180deg);
  }

  .sb-accordion-body {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.25s ease;

    > .sb-accordion-inner {
      overflow: hidden;
      min-height: 0;
    }
  }

  .sb-accordion.open > .sb-accordion-body {
    grid-template-rows: 1fr;
  }

  .sb-accordion-inner {
    margin: 2px 0 5px 15px;
    padding-left: 9px;
    border-left: 1px solid rgba(255, 255, 255, 0.09);
  }

  .sb-link-sub {
    min-height: 42px;
    padding-left: 6px;
    font-size: 12.5px;
    color: rgba(255, 255, 255, 0.72);

    .sb-icon-shell {
      width: 30px;
      height: 30px;
      border-radius: 8px;
    }

    .sb-item-icon svg {
      width: 18px;
      height: 18px;
    }
  }

  /* ---------- desktop: minimizado ---------- */
  @media (min-width: ${BREAKPOINT}px) {
    .sb-close {
      display: none;
    }

    &.collapsed {
      width: ${WIDTH_MIN}px;

      .sb-logo {
        justify-content: center;
        padding: 0;

        img.wide {
          display: none;
        }
        img.mini {
          display: block;
        }
        .sb-btn {
          display: none;
        }
      }

      .sb-label,
      .sb-section-title,
      .sb-chevron {
        display: none;
      }

      /* no rail ficam apenas o home e um ícone por seção */
      .sb-section-body {
        display: none;
      }

      .sb-section {
        margin-top: 7px;
      }

      .sb-link,
      .sb-section-header {
        justify-content: center;
        min-height: 46px;
        padding: 5px 0;
        border-radius: 11px;
        cursor: pointer;
      }

      .sb-link:hover {
        transform: none;
      }

      .sb-icon-shell,
      .sb-icon-shell-section {
        width: 34px;
        height: 34px;
      }

      .sb-section-header:hover {
        background-color: rgba(255, 255, 255, 0.06);

        .sb-icon-shell {
          border-color: rgba(255, 255, 255, 0.14);
          background-color: rgba(255, 255, 255, 0.13);
          transform: scale(1.04);
        }
      }
    }

    &.minimized .sb-toggle .svg-icon {
      transform: rotate(180deg);
    }
  }

  /* ---------- tablet/mobile: drawer ---------- */
  @media (max-width: ${BREAKPOINT - 0.02}px) {
    transform: translateX(-105%);
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);

    &.drawer-open {
      transform: translateX(0);
    }

    .sb-toggle {
      display: none;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    &,
    .sb-btn,
    .sb-link,
    .sb-icon-shell,
    .sb-chevron,
    .sb-accordion-body {
      
    }
  }
`

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 109;
  background: rgba(0, 0, 0, 0.35);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;

  &.show {
    opacity: 1;
    pointer-events: auto;
  }

  @media (min-width: ${BREAKPOINT}px) {
    display: none;
  }
`

const Sidebar: FC = () => {
  const {menuData, isFetching, isLojistasOnly} = useUsermenuData()
  const {isDrawerOpen, closeDrawer, isMinimized, toggleMinimized} = useSidebar()

  // Hover-expand controlado por estado: ao clicar em "recolher" o sidebar
  // fecha na hora (mesmo com o mouse em cima) e o hover só volta a expandir
  // depois que o mouse sai e entra de novo.
  const [isHovered, setIsHovered] = useState(false)
  const [hoverArmed, setHoverArmed] = useState(true)
  const isCollapsed = isMinimized && !(isHovered && hoverArmed)

  const handleToggle = () => {
    setHoverArmed(false)
    toggleMinimized()
  }

  return (
    <>
      <Backdrop className={isDrawerOpen ? 'show' : ''} onClick={closeDrawer} />
      <Styled
        className={`${isMinimized ? 'minimized' : ''} ${isCollapsed ? 'collapsed' : ''} ${
          isDrawerOpen ? 'drawer-open' : ''
        }`}
        aria-label='Menu lateral'
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => {
          setIsHovered(false)
          setHoverArmed(true)
        }}
        onClick={() => {
          // clicar no rail recolhido expande o menu
          if (isCollapsed) {
            setIsHovered(true)
            setHoverArmed(true)
          }
        }}
      >
        <div className='sb-logo'>
          <Link to='/'>
            <img className='wide' alt='Insight Experience' src={toAbsoluteUrl('/media/logos/logo-wide.png')} />
            <img className='mini' alt='Insight Experience' src={toAbsoluteUrl('/media/logos/logo.png')} />
          </Link>
          <button
            type='button'
            className='sb-btn sb-toggle'
            title='Minimizar menu'
            onClick={handleToggle}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr080.svg' className='svg-icon-2 rotate-180' />
          </button>
          <button type='button' className='sb-btn sb-close' title='Fechar menu' onClick={closeDrawer}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
          </button>
        </div>

        <div className='sb-scroll'>
          <SidebarMenu items={menuData} showHome={!isFetching && !isLojistasOnly} />
        </div>
      </Styled>
    </>
  )
}

export {Sidebar}
